import { api_url } from "../../utils/constants";
const axios = require('axios').default;

export const getRequestJSON = (countryName) => {
    return new Promise((resolve, reject) => {
        
        axios({
          method : "GET",
          url :  api_url + "/public/GetServiceCategorySettings",
          params : {"countryName": countryName},
          headers:  { "Content-Type": "application/json" },
        })
        .then(
            (response) =>{
                resolve(response.data);
            }, (error) => {
                console.log(error); 
                reject(error);
            }
        )
    });
}